import { ALL_SUPPORTED_CHAIN_IDS } from 'constants/chains'

export function isNetworkSupported(network: number): boolean {
  if(ALL_SUPPORTED_CHAIN_IDS.includes(network)) {
    return true
  } else {
    return false
  }
}